import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=1a36d92d&scoped=true&"
import script from "./WhiteBoard.vue?vue&type=script&lang=js&"
export * from "./WhiteBoard.vue?vue&type=script&lang=js&"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=1a36d92d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36d92d",
  null
  
)

export default component.exports